import React from 'react';
import { DepositLimitsPanelRoot } from './DepositLimitsPanel.style';

interface DepositLimitsPanelPropsType {
    children: React.ReactNode;
    isDarkMode?: boolean;
}

export const DepositLimitsPanel = ({ children, isDarkMode }: DepositLimitsPanelPropsType): JSX.Element => {
    return <DepositLimitsPanelRoot isDarkMode={isDarkMode}>{children}</DepositLimitsPanelRoot>;
};
